import React, { useEffect } from 'react';

interface SongRedirectProps {
  slug: string;
  url: string;
}

const SongRedirect: React.FC<SongRedirectProps> = ({ slug, url }) => {
  useEffect(() => {
    fbq('trackCustom', 'SongRedirect', { song: slug, destination: 'spotify' });
    gtag('event', 'song_redirect', { song: slug, destination: 'spotify' });
    window.location.replace(url);
  }, [slug, url]);

  return (
    <div className='App'>
      <p>Taking you to Spotify…</p>
    </div>
  );
};

export default SongRedirect;
